<template>
  <div>
    <h2 class="content-heading">
      <i class="si si-basket mr-5"></i> Inkooporder
      <button type="button" class="btn btn-sm btn-success btn-noborder float-right" @click="createOrderListModal">
        <i class="fa fa-plus mr-5"></i>Nieuwe Inkooporder
      </button>
    </h2>

    <api-table-block ref="orderListsTable" :fields="fields" :items="findAllOrders" default-sort-by="created_at" item-label-singular="bestelling" item-label-plural="bestellingen">
      <template slot="name" slot-scope="data">
        <a href="#" @click.prevent="openDetailModal(data.item.id)">#{{data.value}}</a>
      </template>
      <template slot="supplier" slot-scope="data">
        {{data.value}} 
      </template>
      <template slot="created_at" slot-scope="data">
        {{data.value | moment('calendar') | capitalize}}
      </template>
      <template slot="status" slot-scope="data">
        <order-list-status-badge :orderList="data.item" ref="orderListStatusBadge"></order-list-status-badge>
      </template>
      <template slot="actions" slot-scope="data">
        <div class="btn-group" role="group">
          <button class="btn btn-sm btn-secondary  ml-3" @click="openDetailModal(data.item)">Details</button>
          <button v-if="data.item.status === 'delivered' || data.item.status === 'ordered'" class="btn btn-sm btn-secondary  ml-3" @click="openCheckOrderListModal(data.item.id)">Controleren</button>
        </div>
      </template>
    </api-table-block>
    <order-list-detail-modal v-if="detailModalOrderListId " :key="detailModalOrderListId" :orderListId="detailModalOrderListId" @close="detailModalOrderListId = null, refresh()"></order-list-detail-modal>
    <check-order-list-modal v-if="checkOrderListModalId" :orderListId="checkOrderListModalId"  @close="checkOrderListModalId = null, refresh()"></check-order-list-modal>
    <ordered-order-list-modal v-if="orderedOrderModalListId " :key="orderedOrderModalListId" :orderListId="orderedOrderModalListId" :status="currentStatus" @close="orderedOrderModalListId = null, currentStatus = null, refresh()"></ordered-order-list-modal>
    <create-order-list-modal v-if="showCreateOrderListModal" :productIds="[]" :fromScratch="true"  @close="showCreateOrderListModal = null, refresh()"></create-order-list-modal>
    <select-barcode-scanner-widget></select-barcode-scanner-widget>
  </div>
</template>

<script>
import ApiTableBlock from '../common/ApiTableBlock'
import OrderListDetailModal from './OrderListDetailModal.vue'
import OrderedOrderListModal from './OrderedOrderListModal.vue'
import OrderListStatusBadge from './OrderListStatusBadge.vue'
import CheckOrderListModal from './CheckOrderListModal.vue'
import CreateOrderListModal from './CreateOrderListModal.vue'
import SelectBarcodeScannerWidget from '../barcode-scanner/SelectBarcodeScannerWidget.vue'

export default {
  components: {
    ApiTableBlock,
    OrderListDetailModal,
    OrderListStatusBadge,
    OrderedOrderListModal,
    CreateOrderListModal,
    SelectBarcodeScannerWidget,
    CheckOrderListModal
  },
  data () {
    return {
      fields: {
        name: {
          label: 'Naam',
          sortable: true,
          thStyle: 'width: 30%;'
        },
        supplier: {
          label: 'Leverancier',
          sortable: true,
          thStyle: 'width: 25%;'
        },
        created_at: {
          label: 'Datum',
          sortable: true
        },
        status: {
          label: 'Status',
          sortable: true
        },
        actions: {
          label: 'Acties',
          thStyle: 'width: 150px;'
        }
      },
      selectedOrders: [],
      detailModalOrderListId: null,
      orderedOrderModalListId: null,
      currentStatus: null,
      showCreateOrderListModal: null,
      checkOrderListModalId: null
    }
  },
  computed: {
    orderListsTable () {
      return this.$refs.orderListsTable
    }
  },
  methods: {
    findAllOrders (params) {
      params['include'] = 'lines'

      return this.$api.getOrderLists(params)
    },
    refresh () {
      this.orderListsTable.refresh()
    },
    openDetailModal (orderList) {
      if (orderList.status !== 'concept') {
        this.orderedOrderModalListId = orderList.id
        this.currentStatus = orderList.status
      } else {
        this.detailModalOrderListId = orderList.id
      }
    },
    openCheckOrderListModal (id) {
      this.checkOrderListModalId = id
    },
    createOrderListModal () {
      this.showCreateOrderListModal = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrderListPage.vue?6367c82e